/* global windowWidth, breakpointMd, attachEvent */

// **************************************************
// OPEN DROPDOWN [MOBILE]
// **************************************************

const footerTitle = document.querySelector('.footer-main__title');
if (footerTitle) {
  attachEvent('.footer-main__title', 'click', (ev) => {
    if (windowWidth() < breakpointMd) {
      ev.preventDefault();
      const footerTitleParent = ev.target.closest('.col');
      footerTitleParent.classList.toggle('is-open');
    }
  });
}
